"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var Tools_module_css_1 = __importDefault(require("./Tools.module.css"));
var q_play_core_1 = require("@nordicscreen/q-play-core");
var q_play_components_1 = require("@nordicscreen/q-play-components");
var material_1 = require("@mui/material");
var Tools = function () {
    var onlineResourceManager = new q_play_core_1.OnlineResourceManager();
    var _a = (0, q_play_components_1.useModal)(), isShown = _a.isShown, toggle = _a.toggle;
    var _b = (0, react_1.useState)(""), confirmMessage = _b[0], setConfirmMessage = _b[1];
    var _c = (0, react_1.useState)(function () { return toggle; }), confirmCallback = _c[0], setConfirmCallback = _c[1];
    // send bulk player command state variables and functions
    var _d = (0, react_1.useState)([]), deviceTypes = _d[0], setDeviceTypes = _d[1];
    var _e = (0, react_1.useState)(1), selectedDeviceType = _e[0], setSelectedDeviceType = _e[1];
    var _f = (0, react_1.useState)("screenCapture"), playerCommand = _f[0], setPlayerCommand = _f[1];
    var _g = (0, react_1.useState)({ message: "", failed_players: undefined }), playerCommandResponse = _g[0], setPlayerCommandResponse = _g[1];
    var sendBulkPlayerCommand = function () {
        var onlineResource = onlineResourceManager.makeJSONRequest("/api/admin/send-bulk/player-type/".concat(selectedDeviceType, "/command/").concat(playerCommand), "POST");
        onlineResource.getDataAsJSON().then(function (response) {
            setPlayerCommandResponse(response);
        });
    };
    var openBulkCommandConfirmModal = function () {
        setConfirmMessage("Confirm that you want to send the command to all active players of the given type.");
        setConfirmCallback(function () { return sendBulkPlayerCommand; });
        toggle();
    };
    // changing content host state variables
    var _h = (0, react_1.useState)([{ id: 98, hostname: "98.playerapi.q-play.net" }]), availableContentHosts = _h[0], setAvailableContentHosts = _h[1];
    var _j = (0, react_1.useState)(""), playerID = _j[0], setPlayerID = _j[1];
    var _k = (0, react_1.useState)(98), contentHost = _k[0], setContentHost = _k[1];
    var _l = (0, react_1.useState)({ message: "" }), changeContentHostResponse = _l[0], setChangeContentHostResponse = _l[1];
    var changePlayerContentHost = function () {
        var onlineResource = onlineResourceManager.makeJSONRequest("/api/admin/change-content-host/player/".concat(playerID, "/").concat(contentHost), "POST");
        onlineResource.getDataAsJSON().then(function (response) {
            setChangeContentHostResponse(response);
        });
    };
    var openContentHostConfirmModal = function () {
        setConfirmMessage("Confirm that you want to change the content host on the player.");
        setConfirmCallback(function () { return changePlayerContentHost; });
        toggle();
    };
    // load required data
    (0, react_1.useEffect)(function () {
        var sortParam = ["id", "ASC"];
        var loadDeviceType = onlineResourceManager.makeJSONRequest("/api/list/deviceTypes?sort=" + JSON.stringify(sortParam));
        loadDeviceType.getDataAsJSON().then(function (deviceTypes) {
            setDeviceTypes(deviceTypes);
        });
        var loadContentHosts = onlineResourceManager.makeJSONRequest("/api/list/contentHosts?sort=" + JSON.stringify(sortParam) + "&filter=" + JSON.stringify({ "active": 1 }));
        loadContentHosts.getDataAsJSON().then(function (contentHosts) {
            setAvailableContentHosts(contentHosts);
        });
    }, []);
    return (react_1.default.createElement("div", { className: Tools_module_css_1.default["content-area"] },
        react_1.default.createElement("h1", null, "Tools"),
        react_1.default.createElement("div", { className: Tools_module_css_1.default["tool-container"] },
            react_1.default.createElement("div", { className: Tools_module_css_1.default["tool-item"] },
                react_1.default.createElement("div", null,
                    react_1.default.createElement("span", null, "Select player type to send command to:"),
                    react_1.default.createElement(q_play_components_1.Select, { onChange: function (e) { return setSelectedDeviceType(e.target.value); }, defaultValue: 1, className: Tools_module_css_1.default["select-item"] }, deviceTypes.map(function (deviceType) { return (react_1.default.createElement("option", { value: deviceType.id, key: deviceType.id }, deviceType.name)); }))),
                react_1.default.createElement("div", null,
                    react_1.default.createElement("span", null, "Select command to send to players"),
                    react_1.default.createElement(q_play_components_1.Select, { onChange: function (e) { return setPlayerCommand(e.target.value); }, defaultValue: "screenCapture", className: Tools_module_css_1.default["select-item"] },
                        react_1.default.createElement("option", { value: "shutdownDevice" }, "shutdown device"),
                        react_1.default.createElement("option", { value: "rebootDevice" }, "restart hardware"),
                        react_1.default.createElement("option", { value: "relaunchPlayer" }, "restart software"),
                        react_1.default.createElement("option", { value: "exitPlayer" }, "exit player"),
                        react_1.default.createElement("option", { value: "screenCapture" }, "screen capture"),
                        react_1.default.createElement("option", { value: "updateSoftware" }, "update software"),
                        react_1.default.createElement("option", { value: "reloadContent" }, "reload content"),
                        react_1.default.createElement("option", { value: "clearCache" }, "clear cache"))),
                react_1.default.createElement(q_play_components_1.Button, { text: "Send command to players", onClick: openBulkCommandConfirmModal }),
                react_1.default.createElement("span", null, playerCommandResponse.message),
                playerCommandResponse.failed_players && playerCommandResponse.failed_players.map(function (failedPlayer) { return (react_1.default.createElement(material_1.Box, { key: failedPlayer.id, sx: {
                        display: "flex",
                        columnGap: "20px"
                    } },
                    react_1.default.createElement("span", null,
                        "player id: ",
                        failedPlayer.id,
                        ","),
                    react_1.default.createElement("span", null,
                        "player name: ",
                        failedPlayer.name,
                        ","),
                    react_1.default.createElement("span", null,
                        "account id: ",
                        failedPlayer.account))); })),
            react_1.default.createElement("div", { className: Tools_module_css_1.default["tool-item"] },
                react_1.default.createElement("div", null,
                    react_1.default.createElement("span", null, "Insert player ID:"),
                    react_1.default.createElement(q_play_components_1.Input, { placeholder: "player ID", value: playerID, onChange: function (e) { return setPlayerID(e.target.value); } })),
                react_1.default.createElement("div", null,
                    react_1.default.createElement("span", null, "Select content host"),
                    react_1.default.createElement(q_play_components_1.Select, { onChange: function (e) { return setContentHost(e.target.value); }, className: Tools_module_css_1.default["select-item"] }, availableContentHosts.map(function (contentHost) { return (react_1.default.createElement("option", { value: contentHost.id, key: contentHost.id }, contentHost.hostname)); }))),
                react_1.default.createElement(q_play_components_1.Button, { text: "Change content host", onClick: openContentHostConfirmModal }),
                react_1.default.createElement("span", null, changeContentHostResponse.message))),
        react_1.default.createElement(q_play_components_1.ConfirmationModal, { isShown: isShown, message: confirmMessage, onConfirm: function () { confirmCallback(); toggle(); }, onCancel: toggle, onClose: toggle })));
};
exports.default = Tools;
